import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';

import { OnboardingProvider } from '../../context';
import { useInitializeSteps } from '../../hooks/useInitializeSteps';
import { useProxyWizard } from '../../hooks/useProxyWizard';

import { layoutSteps, layoutStepsKeys } from './constants';
import { LayoutDataType } from './types';
import { normalizeOnbDataToForm } from './utils/normalizeOnbDataToForm';

const LayoutOwnAI_W: React.FC = () => {
  const { user } = useAccount();

  const { proxyWizard, step } = useProxyWizard(layoutStepsKeys, layoutSteps);

  useInitializeSteps(proxyWizard, layoutStepsKeys);

  const normalizedOnbData = normalizeOnbDataToForm(user?.onboarding_data ?? {});

  const form = useForm<LayoutDataType>({
    defaultValues: normalizedOnbData,
    values: normalizedOnbData,
  });

  const StepComponent = layoutSteps[step as keyof typeof layoutSteps].component;

  return (
    <OnboardingProvider wizard={proxyWizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutOwnAI_W;
